import { Col, Form as BSForm, Row } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactDatePicker from 'react-datepicker';
import SigniteTextArea from '../../../../ui-elements/signite-text-area/signiteTextArea';
import { getErrorClass, getErrorMessage } from '../../../../../utils/errorUtils';
import { MasterDataService } from '../../../../../services/masterDataService';
import { useEffect, useState } from 'react';

export const PreviousJobForm = ({ handleChange, job, index, handleBlur, errors, touched, values, cities, industrySectors, functions, setFieldValue }) => {
  const toDate = (value) => {
    if (!value) return null;

    if (typeof value === 'number' && !isNaN(value)) {
      return new Date(value);
    }

    if (typeof value === 'string' && !isNaN(Date.parse(value))) {
      return new Date(value);
    }

    return value ? new Date(value) : null;
  };

  const startDate = toDate(job.roleStartDate);
  const endDate = toDate(job.roleEndDate);

  const [selectedIndustryId, setSelectedIndustryId] = useState(null);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    if (!industrySectors || industrySectors.length === 0) return;

    if (job?.industrySector) {
      const match = industrySectors.find(
        (s) => s.industrySector?.toLowerCase() === (job.industrySector || '').toLowerCase()
      );
      if (match) {
        const id = match.id;
        setSelectedIndustryId(id);
        MasterDataService.getIndustrySubcategories(id)
          .then((res) => setSubcategories(res.data || []))
          .catch((err) => console.error('Failed to load subcategories for previous job:', err));
      }
    }
  }, [industrySectors, job?.industrySector]);

  const onIndustrySelect = async (e) => {
    const id = e.target.value || null;
    setSelectedIndustryId(id);

    if (!id) {
      setFieldValue(`previousJobs.${index}.industrySector`, '');
      setFieldValue(`previousJobs.${index}.subcategory`, '');
      setSubcategories([]);
      return;
    }

    const match = industrySectors.find((s) => s.id == id);
    const label = match?.industrySector || '';
    setFieldValue(`previousJobs.${index}.industrySector`, label);
    setFieldValue(`previousJobs.${index}.subcategory`, '');

    try {
      const res = await MasterDataService.getIndustrySubcategories(id);
      setSubcategories(res.data || []);
    } catch (err) {
      console.error('Failed to load subcategories for previous job:', err);
      setSubcategories([]);
    }
  };

  const [selectedFunctionId, setSelectedFunctionId] = useState(null);
  const [functionSubcategories, setFunctionSubcategories] = useState([]);

  useEffect(() => {
    if (job.function) {
      const match = functions.find((f) => f.function === job.function);
      if (match) {
        setSelectedFunctionId(match.id);
        MasterDataService.getFunctionSubcategories(match.id)
          .then((res) => setFunctionSubcategories(res.data || []));
      }
    }
  }, [functions, job.function]);

  const onFunctionSelect = async (e) => {
    const id = e.target.value;
    setSelectedFunctionId(id);

    if (!id) {
      setFieldValue(`previousJobs.${index}.function`, "");
      setFieldValue(`previousJobs.${index}.functionSubcategory`, "");
      setFunctionSubcategories([]);
      return;
    }

    const match = functions.find((f) => f.id == id);
    setFieldValue(`previousJobs.${index}.function`, match?.function || "");
    setFieldValue(`previousJobs.${index}.functionSubcategory`, "");

    try {
      const res = await MasterDataService.getFunctionSubcategories(id);
      setFunctionSubcategories(res.data || []);
    } catch (err) {
      setFunctionSubcategories([]);
    }
  };

  return (
    <div className="signite-form">
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Designation*</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`previousJobs.${index}.designation`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.designation`)}`}
            value={job.designation}
            required
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.designation`)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Organization Name*</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`previousJobs.${index}.organizationName`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.organizationName`)}`}
            value={job.organizationName}
            required
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.organizationName`)}</span>
        </BSForm.Group>
        {/* <BSForm.Group as={Col}>
          <BSForm.Label>Industry/ Sector*</BSForm.Label>
          <BSForm.Control
            type="text"
            name={`previousJobs.${index}.industrySector`}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.industrySector`)}`}
            value={job.industrySector}
            required
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.industrySector`)}</span>
        </BSForm.Group> */}
        <BSForm.Group as={Col}>
          <BSForm.Label>Industry / Sector*</BSForm.Label>
          <BSForm.Select
            name={`previousJobs.${index}.industrySector_select`}
            value={selectedIndustryId || ''}
            onChange={onIndustrySelect}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.industrySector`)}`}
            required
          >
            <option value="">Select Industry</option>
            {(industrySectors || []).map((sec) => (
              <option key={sec.id} value={sec.id}>
                {sec.industrySector}
              </option>
            ))}
          </BSForm.Select>
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.industrySector`)}</span>
        </BSForm.Group>
      </Row>
      <Row className="mb-3">
        <BSForm.Group as={Col}>
          <BSForm.Label>Industry Subcategory</BSForm.Label>
          {subcategories && subcategories.length > 0 ? (
            <BSForm.Select
              name={`previousJobs.${index}.subcategory`}
              value={job.subcategory || ''}
              onChange={handleChange}
            >
              <option value="">Select Subcategory</option>
              {subcategories.map((sub) => (
                <option key={sub.id} value={sub.subcategory}>
                  {sub.subcategory}
                </option>
              ))}
            </BSForm.Select>
          ) : (
            <BSForm.Control
              type="text"
              name={`previousJobs.${index}.subcategory`}
              onChange={handleChange}
              onBlur={handleBlur}
              value={job.subcategory || ''}
              placeholder="Select industry to load subcategories"
              disabled
            />
          )}
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.subcategory`)}</span>
        </BSForm.Group>

        <BSForm.Group as={Col}>
          <BSForm.Label>Function</BSForm.Label>
          <BSForm.Select
            name={`previousJobs.${index}.function_select`}
            value={selectedFunctionId || ""}
            onChange={onFunctionSelect}
          >
            <option value="">Select Function</option>
            {functions.map((fn) => (
              <option key={fn.id} value={fn.id}>
                {fn.function}
              </option>
            ))}
          </BSForm.Select>
        </BSForm.Group>

        <BSForm.Group as={Col}>
          <BSForm.Label>Function Subcategory</BSForm.Label>
          {functionSubcategories.length > 0 ? (
            <BSForm.Select
              name={`previousJobs.${index}.functionSubcategory`}
              value={job.functionSubcategory}
              onChange={handleChange}
            >
              <option value="">Select Subcategory</option>
              {functionSubcategories.map((sub) => (
                <option key={sub.id} value={sub.subcategory}>
                  {sub.subcategory}
                </option>
              ))}
            </BSForm.Select>
          ) : (
            <BSForm.Control disabled placeholder="Select function first" />
          )}
        </BSForm.Group>

        <BSForm.Group as={Col}>
          <BSForm.Label>Location</BSForm.Label>
          <BSForm.Select
            name={`previousJobs.${index}.location`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={job.location}
          >
            <option value="">Select a city</option>
            {cities.map((city) => (
              <option key={city} value={city}>
                {city}
              </option>
            ))}
          </BSForm.Select>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>Start MM/YYYY</BSForm.Label>
          <ReactDatePicker
            name={`previousJobs.${index}.roleStartDate`}
            selected={startDate}
            onChange={(val) => setFieldValue(`previousJobs.${index}.roleStartDate`, val, true)}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.roleStartDate`)}`}
            dateFormat="MM/yyyy"
            maxDate={new Date()}
            showMonthYearPicker
            autoComplete="off"
          />

          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.roleStartDate`)}</span>
        </BSForm.Group>
        <BSForm.Group as={Col}>
          <BSForm.Label>End Date</BSForm.Label>
          <ReactDatePicker
            name={`previousJobs.${index}.roleEndDate`}
            selected={endDate ? new Date(endDate) : null}
            onChange={(val) => setFieldValue(`previousJobs.${index}.roleEndDate`, val, true)}
            onBlur={handleBlur}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.roleEndDate`)}`}
            dateFormat="MM/yyyy"
            maxDate={new Date()}
            showMonthYearPicker
            autoComplete="off"
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.roleEndDate`)}</span>
        </BSForm.Group>
      </Row>
      <Row>
        <BSForm.Group as={Col}>
          <BSForm.Label>My Top 3 Responsibilities are</BSForm.Label>
          <SigniteTextArea
            name={`previousJobs.${index}.top3Responsibilities`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={_.get(values, `previousJobs.${index}.top3Responsibilities`)}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.top3Responsibilities`)}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.top3Responsibilities`)}</span>
        </BSForm.Group>
      </Row>
      <Row>
        <BSForm.Group as={Col}>
          <BSForm.Label>My Top 3 Achievements are</BSForm.Label>
          <SigniteTextArea
            name={`previousJobs.${index}.top3Achievements`}
            onChange={handleChange}
            onBlur={handleBlur}
            value={_.get(values, `previousJobs.${index}.top3Achievements`)}
            className={`form-control ${getErrorClass(errors, touched, `previousJobs.${index}.top3Achievements`)}`}
          />
          <span className="errorMessage">{getErrorMessage(errors, touched, `previousJobs.${index}.top3Achievements`)}</span>
        </BSForm.Group>
      </Row>
    </div>
  );
};